var _circle, _circle2, _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThoughtLeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#3F234B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 12.9375,
    stroke: "url(#paint0_linear_83_56445)",
    strokeWidth: 1.125
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.748 19.725C10.6032 19.725 10.4781 19.6241 10.4473 19.4827L9.13651 13.453C9.08162 13.2004 9.34364 12.9968 9.57479 13.1124L11.7648 14.2074C11.9003 14.2751 12.0648 14.2343 12.1528 14.1111L14.7496 10.4755C14.8723 10.3037 15.1277 10.3037 15.2504 10.4755L17.8472 14.1111C17.9352 14.2343 18.0997 14.2751 18.2352 14.2074L20.4252 13.1124C20.6564 12.9968 20.9184 13.2004 20.8635 13.453L19.5527 19.4827C19.5219 19.6241 19.3968 19.725 19.252 19.725H10.748Z",
    fill: "url(#paint1_linear_83_56445)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_83_56445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9734 12.7676L17.6462 13.6403L16.7734 13.9676L17.6462 14.2949L17.9734 15.1676L18.3007 14.2949L19.1734 13.9676L18.3007 13.6403L17.9734 12.7676Z",
    fill: "#FDF3F3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9988 17.6227C15.3171 17.6227 15.6223 17.4962 15.8474 17.2712C16.0724 17.0461 16.1988 16.7409 16.1988 16.4227C16.1988 16.1044 16.0724 15.7992 15.8474 15.5741C15.6223 15.3491 15.3171 15.2227 14.9988 15.2227C14.6806 15.2227 14.3753 15.3491 14.1503 15.5741C13.9253 15.7992 13.7988 16.1044 13.7988 16.4227C13.7988 16.7409 13.9253 17.0461 14.1503 17.2712C14.3753 17.4962 14.6806 17.6227 14.9988 17.6227Z",
    fill: "#FDF3F3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_83_56445",
    x: 15.5427,
    y: 11.5368,
    width: 4.86144,
    height: 4.86193,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.615385,
    result: "effect1_foregroundBlur_83_56445"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_83_56445",
    x1: 15,
    y1: 1.5,
    x2: 15,
    y2: 28.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78CA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_83_56445",
    x1: 15,
    y1: 10.125,
    x2: 15,
    y2: 19.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78CA2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThoughtLeader);
export default __webpack_public_path__ + "static/media/thought-leader.dbefcbeeeea0b04671d766bcca8664a4.svg";
export { ForwardRef as ReactComponent };